<template>
  <div style="width:100%;float:left;padding-top:15px;">
    <!-- {{program.program_name}} -->
    <CCard>
      <CCardHeader color="info" style="color:#fff;">{{program.program_name}}</CCardHeader>
      <CCardBody>
        <CDataTable
          v-if="form"
          :items="form.techniques"
          :fields="fields"
          table-filter
        >
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.getProgram = function () {
  let self = this;
  this.form = null
  axios.get(   this.$apiAdress + '/api/programs/edit?token=' + localStorage.getItem("api_token") + '&program_id=' + self.program.program_id)
  .then(function (response) {
      // self.name = response.data.menulist.name;
      self.form = response.data.res
      // self.locations = response.data.locations
      console.log(response)
  }).catch(function (error) {
      console.log(error);
      // self.$router.push({ path: '/login' });
  });
}

export default {
  // ===Component name
  name: "LeadTimesTable",
  // ===Props passed to component
  props: ['program'],
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        form: '',
        fields: [
          {label: 'Technique', key: 'technique_name'},
          {label: 'Min Quant', key: 'min_quantity'},
          {label: 'New Min Quant', key: 'new_min_quantity'},
          {label: 'Cost', key: 'cost'},
          {label: 'Lead Time', key: 'lead_time'},
        ]
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getProgram()
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
